import { render, staticRenderFns } from "./dashboardMaterial.vue?vue&type=template&id=648f918f&"
import script from "./dashboardMaterial.vue?vue&type=script&lang=js&"
export * from "./dashboardMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports